<template>
    <div>
        <div v-loading="loadingView"></div>
        <div v-if="!loadingView" class="detail-page">
            <!-- <div class="detail-status">
                <Status :status="status"></Status>
            </div> -->

            <wrapper title="基本信息">
                <Item :item="itemContent" :brands="brands"></Item>
            </wrapper>

            <div class="pane bind-product">
                <div class="title">
                    <Title text="合作详情"></Title>
                    <el-button v-if="type === '1'" class="op-btn" size="medium" type="primary" @click="handleAddProduct"
                        >绑定产品</el-button
                    >
                </div>
                <div class="content">
                    <product
                        :detailType="type"
                        :link="detail.link || ''"
                        :steps="steps"
                        :customerId="customerId"
                        :product="detail.product || []"
                        @export-succ="onExportSucc"
                        @import-succ="onImportSucc"
                        @update-step-succ="onUpdateStepSucc"
                    ></product>
                </div>
            </div>

            <wrapper title="跟进日报">
                <log :steps="steps" :step-log="logInfo.stepLog || []" :trans-log="logInfo.syslog || []"> </log>
            </wrapper>

            <template v-if="hasInfo">
                <wrapper title="客户联系人信息">
                    <contact :contact="contacterData"></contact>
                </wrapper>

                <wrapper title="其他信息">
                    <other :info="detail || {}"></other>
                </wrapper>

                <wrapper title="资质信息" v-if="Number(type) === advType.private.id">
                    <license :license="license" :qualification="qualification" :code="(detail || {}).license_code">
                    </license>
                </wrapper>
            </template>

            <!-- 绑定合作产品的弹窗 -->
            <form-dialog
                :visible.sync="addProductForm.display"
                title="请绑定合作产品"
                :loading="addProductForm.loading"
                @submit="submitAddProductFormAction"
                @close="closeAddProductDialog"
                width="500px"
            >
                <el-form
                    :model="addProductForm.form"
                    :rules="addProductForm.rules"
                    ref="addProductForm"
                    label-width="120px"
                    class="dialog-bind-product-form"
                >
                    <el-form-item label="合作产品" prop="product">
                        <el-select
                            v-model="addProductForm.form.product"
                            multiple
                            filterable
                            remote
                            :remote-method="_fetchProduct"
                            placeholder="请选择合作产品"
                            style="width: 100%"
                            ref="productSelect"
                        >
                            <el-option
                                v-for="item in productOpt"
                                :key="item.product_id"
                                :label="item.product_name"
                                :value="item.product_id"
                                :disabled="checkBind(item)"
                            >
                                <template>
                                    <el-tooltip
                                        v-if="checkBind(item)"
                                        effect="dark"
                                        :content="disableTip(item)"
                                        placement="top"
                                    >
                                        <span>{{ item.product_name }}</span>
                                    </el-tooltip>
                                    <div v-else>
                                        <span>{{ item.product_name }}</span>
                                    </div>
                                </template>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </form-dialog>
        </div>
    </div>
</template>

<script>
import Index from './index.js';
export default Index;
</script>

<style lang="less" scoped>
.detail-page {
    position: relative;

    .detail-status {
        position: absolute;
        top: -40px;
        left: -40px;
        z-index: 1;
    }

    .pane {
        margin-bottom: 48px;

        .title {
            position: relative;
            margin-bottom: 28px;

            .op-btn {
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    }
    .bind-product {
        /deep/ .el-button--medium {
            padding: 9px 24px;
            font-size: 12px;
        }
    }
    .dialog-bind-product-form {
        /deep/ .el-form-item {
            margin-bottom: 0;
        }
        /deep/ .el-form-item__label {
            text-align: center;
        }
        /deep/ .el-select .el-tag {
            background-color: #f2f9ff;
        }
        /deep/ .el-select__tags-text {
            color: #2f9eff;
        }
        /deep/ .el-select .el-tag__close.el-icon-close {
            background-color: #b2dbff;
        }
    }
}
</style>
